import { createFileRoute } from "@tanstack/react-router";
import { ReadOnlyPill } from "@/components/auth/ReadOnlyPill";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PmPlansTab } from "@/features/pm/PmPlansTab";
import { AssetsWithoutPmTab } from "@/features/pm/AssetsWithoutPmTab";
import { PmCalendarTab } from "@/features/pm/PmCalendarTab";
import { RouteGuard } from "@/components/auth/RouteGuard";

type Search = { tab?: "plans" | "assets" | "calendar"; overdue?: boolean; status?: string };

export const Route = createFileRoute("/_authenticated/preventive-maintenance")({
  component: () => (
    <RouteGuard module="pm"><PreventiveMaintenancePage /></RouteGuard>
  ),
  validateSearch: (s: Record<string, unknown>): Search => ({
    tab: (s.tab as Search["tab"]) ?? "plans",
    overdue: s.overdue === true || s.overdue === "true",
    status: s.status as string | undefined,
  }),
});

function PreventiveMaintenancePage() {
  const { tab, overdue, status } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Preventive Maintenance</h1> <ReadOnlyPill module="pm" />
        <p className="text-sm text-muted-foreground">Plan, schedule and track PMs across all assets.</p>
      </div>
      <Tabs value={tab} onValueChange={(v) => navigate({ search: { tab: v as Search["tab"], overdue } })}>
        <TabsList>
          <TabsTrigger value="plans">PM Plans</TabsTrigger>
          <TabsTrigger value="assets">Assets Without PM Plan</TabsTrigger>
          <TabsTrigger value="calendar">PM Calendar</TabsTrigger>
        </TabsList>
        <TabsContent value="plans" className="mt-4">
          <PmPlansTab initialOverdue={overdue} initialStatus={status} />
        </TabsContent>
        <TabsContent value="assets" className="mt-4">
          <AssetsWithoutPmTab />
        </TabsContent>
        <TabsContent value="calendar" className="mt-4">
          <PmCalendarTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
